import { render, staticRenderFns } from "./USFooter.vue?vue&type=template&id=60f6c442&scoped=true&"
import script from "./USFooter.vue?vue&type=script&lang=js&"
export * from "./USFooter.vue?vue&type=script&lang=js&"
import style0 from "./USFooter.vue?vue&type=style&index=0&id=60f6c442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6c442",
  null
  
)

export default component.exports